import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import ShowDetailState from './showDetail';
import HomeState from './home';
import ShowListState from './showList';
import ShowBookingState from './showBooking';
import orderListState from './orderList';
import orderBookingState from './orderBooking';
import cancelOrderState from './cancelOrder';
import orderDetailState from './orderDetail';
import verificationCodeState from './verificationCode';
import getPHPLinkState from './getPHPLink';
import getSeatInfoState from './getSeatInfo';
import getQueryPhoneState from './getUserPhone';
import addressState from './address';
import logisticsState from './logistics';
import payResultState from './payResult';
import noticeResult from './noticeCon';

const history = createBrowserHistory();
const rootReducer = combineReducers({
  ShowDetailState,
  HomeState,
  ShowListState,
  ShowBookingState,
  orderListState,
  orderBookingState,
  cancelOrderState,
  orderDetailState,
  verificationCodeState,
  getPHPLinkState,
  getSeatInfoState,
  getQueryPhoneState,
  addressState,
  logisticsState,
  payResultState,
  noticeResult,
  // 。。。这里继续加
  router: connectRouter(history),
});
export default rootReducer;
